import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeStatusForm from '../../../components/forms/RangeStatusForm';
import { useCreateRangeStatus } from '../../../hooks/useRangeStatusApi';
import { useNavigate } from 'react-router-dom';
import { RangeStatusDTO } from '../../../services/apiClient';

const RangeStatusCreate: React.FC = () => {
  const createMutation = useCreateRangeStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Statuses', href: '/admin/rangestatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RangeStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/rangestatuses');
    } catch (error) {
      console.error('Error creating RangeStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RangeStatus.Edit"
    >
        <RangeStatusForm
          initialValues={{} as RangeStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/rangestatuses')}
        />
    </AdminLayout>
  );
};

export default RangeStatusCreate;
